export type Fakultas = {
  master_fakultas_id: string;
  kode_fakultas: string;
  nama_fakultas: string;
  created_at: string;
  updated_at: string | null;
  deleted_at: string | null;
};

export type FakultasResponse = {
  datas: Fakultas[];
  is_next: boolean;
  status: string;
};

import { apiClient } from "@/lib/api-client";

export const fetchFakultas = async ({ pageParam = 1 }: { pageParam?: number } = {}): Promise<FakultasResponse> => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;
  return apiClient<FakultasResponse>(`${baseUrl}/api/v1/master-fakultas?page=${pageParam}`);
};
